import { RefObject, useEffect } from 'react'

type EventType = MouseEvent | TouchEvent

function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T> | RefObject<T>[],
  handler: (event: EventType) => void
): void {
  const refs = Array.isArray(ref) ? ref : [ref]

  useEffect(() => {
    const listener = (event: EventType) => {
      const isInside = refs.some(
        (r) => r.current && event.target instanceof Node && r.current.contains(event.target)
      )
      if (isInside) return
      handler(event)
    }

    document.addEventListener('click', listener)

    return () => {
      document.removeEventListener('click', listener)
    }
  }, [ref, handler])
}

export default useClickOutside
